import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
    cashLimitsType,
    sortingParamType,
} from '../../types';
import CashLimitRow from './CashLimitRow';
import SortControl from '../SortControl';

CashLimitsList.propTypes = {
    cashLimits: cashLimitsType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function CashLimitsList(props) {
    const {
        cashLimits,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="cash-limits-list">
            <div className="rich-list-row rich-list-header cash-limits-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="cash-limit-header--values--main-id">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="mainId">
                        {t('cash-limits.list-header.main-id')}
                    </SortControl>
                </div>
                <div className="cash-limit-header--values--member">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="member.memberId">
                        {t('cash-limits.list-header.member')}
                    </SortControl>
                </div>
                <div className="cash-limit-header--values--limit-value">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="limitValue">
                        {t('cash-limits.list-header.limit-value')}
                    </SortControl>
                </div>
                <div className="cash-limit-header--values--begin-date">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="beginDate">
                        {t('cash-limits.list-header.begin-date')}
                    </SortControl>
                </div>
                <div className="cash-limit-header--values--end-date">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="endDate">
                        {t('cash-limits.list-header.end-date')}
                    </SortControl>
                </div>
                <div className="cash-limit-header--values--creator">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="creator">
                        {t('cash-limits.list-header.creator')}
                    </SortControl>
                </div>
                <div className="cash-limit-header--values--status">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="status">
                        {t('cash-limits.list-header.status')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                cashLimits.length
                    ? cashLimits.map((cashLimit) => (
                        <CashLimitRow
                            cashLimit={cashLimit}
                            key={cashLimit.id}
                        />
                    ))
                    : (
                        <div className="cash-limits-no-items">
                            {t('cash-limits.no-items')}
                        </div>
                    )
            }
        </div>
    );
}

export default CashLimitsList;
